import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/my").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  if (!user) return null;

  return (
    <main className="max-w-[1100px] mx-auto px-6 lg:px-10 py-16">
      <div className="overline">Your account</div>
      <h1 className="font-serif text-5xl mt-3">{user.name}</h1>
      <div className="text-[#5c5a56] mt-2">{user.email}</div>

      <div className="mt-16">
        <h2 className="font-serif text-3xl mb-6">Orders</h2>
        {orders.length === 0 ? (
          <div className="text-[#5c5a56]">You haven't placed any orders yet.</div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.id} className="border border-[#ebe5df] p-5 grid sm:grid-cols-4 gap-4" data-testid={`order-${o.id}`}>
                <div>
                  <div className="overline">Order</div>
                  <div className="font-serif text-lg mt-1">#{o.id.slice(0, 8)}</div>
                </div>
                <div>
                  <div className="overline">Total</div>
                  <div className="font-serif text-lg mt-1">₹{o.total.toLocaleString("en-IN")}</div>
                </div>
                <div>
                  <div className="overline">Status</div>
                  <div className="font-medium text-sm mt-1 capitalize">{o.status.replace(/_/g, " ")}</div>
                </div>
                <div>
                  <div className="overline">Placed</div>
                  <div className="text-sm mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
